<template>
  <!--トップへ戻るボタン-->
  <v-btn
  :v-scroll="onScroll"
  :v-show="ifScroll"
  id="toTop"
  rounded
  dark
  fixed
  x-large
  bottom
  right
  color="grey darken-3"
  @click="toTop()">
  To Top
    <v-icon>
      mdi-chevron-up
    </v-icon>
  </v-btn>
</template>

<style>
#toTop {
  z-index: 100;
}
</style>

<script>
export default {
  data () {
    return {
      ifScroll: false
    }
  },
  methods: {
    onScroll (e) {
      var top = (window.pageYOffset !== 'undefined') ? window.pageYOffset : e.target.scrollTop
      this.ifScroll = top > 20
      return top
      // if (typeof window === 'undefined') {
      //   const top = window.pageYOffset || e.target.scrollTop || 0
      //   this.fab = top > 20
      //   return top
      // }
    },
    toTop () {
      this.$vuetify.goTo(0)
    }
  }
}
</script>
